import { formatAsUriParameters, get } from '@namespace/helpers';
import { IGetFeedCategoryResponse, PlatformType } from '../../../../types';

interface IGetFeedCategoriesParams {
  platform: PlatformType;
  lang: string;
  feedName: string;
  filter?: {
    limit?: number;
    offset?: number;
  };
}

export const getFeedCategories = ({
  platform,
  lang,
  feedName,
  filter = {} // userSegments
}: IGetFeedCategoriesParams): Promise<IGetFeedCategoryResponse[]> => {
  return get(
    `/service/plex/v1/${platform}/${lang}/gamesFeeds/${feedName}/categories?${formatAsUriParameters(
      filter
    )}`
  );
};
